import { render, staticRenderFns } from "./ColleaguesList.vue?vue&type=template&id=1d325946&scoped=true&"
import script from "./ColleaguesList.vue?vue&type=script&lang=js&"
export * from "./ColleaguesList.vue?vue&type=script&lang=js&"
import style0 from "./ColleaguesList.vue?vue&type=style&index=0&id=1d325946&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d325946",
  null
  
)

export default component.exports